import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ErrorPage, PageBreadcrumbProps, PageLayout } from "../../";
import { OrganizationService } from "../../../services";
import { generateOrganizationBreadcrumbs, OrganizationTopbar } from "./";
import { useAsync, PageTitleProvider, usePageTitle, useUrlParams } from "../../../hooks";
import { BreadcrumbProps } from "../../../components";

function BaseLayout() {
  const organizationService = new OrganizationService();
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<PageBreadcrumbProps>();
  const { title } = usePageTitle();
  const id = parseInt(useUrlParams("id"));

  const { value: organization, loading, error } = useAsync(() => organizationService.get(id), [id]);

/**
   * Initialize breadcrumbs for the page depending on the route
   */
  useEffect(() => {
    if(id) {
      const newBreadcrumbs:BreadcrumbProps = generateOrganizationBreadcrumbs(location.pathname, organization?.name ?? "", id);
      setBreadcrumbs(newBreadcrumbs);
    }
  }, [location.pathname, organization, id])

  if(loading) return <></>
  if(error){
    return <ErrorPage message={error.message} />
  }
  return (
    <PageLayout title={title} topbar={<OrganizationTopbar />} breadcrumbs={breadcrumbs}>
      <Outlet/>
    </PageLayout>
  )
}

export function OrganizationLayout() {
  // Wrap the BaseUserLayout in a PageTitleProvider.
  // This prevents an error of the context not being initialized when the usePageTitle hook is called.
  return (
    <PageTitleProvider>
      <BaseLayout />
    </PageTitleProvider>
  );
}

export default OrganizationLayout
